export function generateSessionId(): string {
	if (
		typeof globalThis !== 'undefined' &&
		globalThis.crypto &&
		typeof globalThis.crypto.randomUUID === 'function'
	) {
		return globalThis.crypto.randomUUID();
	}
	return `dwell-${Date.now().toString(36)}-${Math.random().toString(36).slice(2, 10)}`;
}
